export const mockJobs = [
  {
    id: "JOB-001",
    jobId: "JRN-10234",
    customer: {
      name: "Mary Kariuki",
      phone: "+254 712 345 678",
      avatar: null,
      location: "Westlands, Nairobi",
      totalOrders: 12,
      totalSpend: 24500
    },
    pro: {
      name: "Grace Wanjiku",
      phone: "+254 798 111 222",
      avatar: null,
      rating: 4.8,
      category: "Cleaning"
    },
    category: "Cleaning",
    location: "Westlands, Nairobi",
    date: "2024-07-15",
    scheduledTime: "09:00 AM",
    price: 3500,
    paymentStatus: "paid",
    status: "completed",
    timeline: [
      { event: "Job Requested", time: "2024-07-14T08:00:00" },
      { event: "Pro Assigned", time: "2024-07-14T09:30:00" },
      { event: "Job Started", time: "2024-07-15T09:05:00" },
      { event: "Job Completed", time: "2024-07-15T11:30:00" }
    ],
    messages: [
      { sender: "customer", text: "Please bring your own supplies.", time: "2024-07-14T10:00:00" },
      { sender: "pro", text: "Noted, I will come prepared.", time: "2024-07-14T10:05:00" },
      { sender: "customer", text: "Great, see you tomorrow.", time: "2024-07-14T10:06:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-002",
    jobId: "JRN-10235",
    customer: {
      name: "James Ndirangu",
      phone: "+254 723 456 789",
      avatar: null,
      location: "Kilimani, Nairobi",
      totalOrders: 8,
      totalSpend: 18200
    },
    pro: {
      name: "Brian Otieno",
      phone: "+254 798 222 333",
      avatar: null,
      rating: 4.7,
      category: "Plumbing"
    },
    category: "Plumbing",
    location: "Kilimani, Nairobi",
    date: "2024-07-18",
    scheduledTime: "02:00 PM",
    price: 3800,
    paymentStatus: "paid",
    status: "completed",
    timeline: [
      { event: "Job Requested", time: "2024-07-17T09:00:00" },
      { event: "Pro Assigned", time: "2024-07-17T10:30:00" },
      { event: "Job Started", time: "2024-07-18T14:10:00" },
      { event: "Job Completed", time: "2024-07-18T16:30:00" }
    ],
    messages: [
      { sender: "customer", text: "Kitchen sink is blocked", time: "2024-07-17T09:05:00" },
      { sender: "pro", text: "I'll be there at 2 PM", time: "2024-07-17T10:35:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-003",
    jobId: "JRN-10236",
    customer: {
      name: "Susan Muthoni",
      phone: "+254 734 567 890",
      avatar: null,
      location: "Karen, Nairobi",
      totalOrders: 3,
      totalSpend: 6800
    },
    pro: {
      name: "Samuel Kamau",
      phone: "+254 798 333 444",
      avatar: null,
      rating: 4.6,
      category: "Electrical"
    },
    category: "Electrical",
    location: "Karen, Nairobi",
    date: "2024-07-20",
    scheduledTime: "10:00 AM",
    price: 5500,
    paymentStatus: "pending",
    status: "in_progress",
    timeline: [
      { event: "Job Requested", time: "2024-07-19T08:00:00" },
      { event: "Pro Assigned", time: "2024-07-19T09:30:00" },
      { event: "Job Started", time: "2024-07-20T10:15:00" }
    ],
    messages: [
      { sender: "customer", text: "Need help with wiring", time: "2024-07-19T08:10:00" },
      { sender: "pro", text: "On my way", time: "2024-07-20T09:55:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-004",
    jobId: "JRN-10237",
    customer: {
      name: "Peter Oloo",
      phone: "+254 745 678 901",
      avatar: null,
      location: "Lavington, Nairobi",
      totalOrders: 19,
      totalSpend: 41000
    },
    pro: {
      name: "Amina Hassan",
      phone: "+254 798 444 555",
      avatar: null,
      rating: 4.8,
      category: "Tutoring"
    },
    category: "Tutoring",
    location: "Lavington, Nairobi",
    date: "2024-07-21",
    scheduledTime: "03:00 PM",
    price: 1800,
    paymentStatus: "paid",
    status: "in_progress",
    timeline: [
      { event: "Job Requested", time: "2024-07-20T10:00:00" },
      { event: "Pro Assigned", time: "2024-07-20T11:30:00" },
      { event: "Job Started", time: "2024-07-21T15:15:00" }
    ],
    messages: [
      { sender: "customer", text: "Focus on mathematics", time: "2024-07-20T10:15:00" },
      { sender: "pro", text: "I have prepared materials", time: "2024-07-20T11:35:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-005",
    jobId: "JRN-10238",
    customer: {
      name: "Alice Wambui",
      phone: "+254 756 789 012",
      avatar: null,
      location: "Parklands, Nairobi",
      totalOrders: 1,
      totalSpend: 1500
    },
    pro: null,
    category: "Gardening",
    location: "Parklands, Nairobi",
    date: "2024-07-22",
    scheduledTime: "08:00 AM",
    price: 3200,
    paymentStatus: "pending",
    status: "requested",
    timeline: [
      { event: "Job Requested", time: "2024-07-21T14:00:00" }
    ],
    messages: [],
    dispute: null
  },
  {
    id: "JOB-006",
    jobId: "JRN-10239",
    customer: {
      name: "David Langat",
      phone: "+254 767 890 123",
      avatar: null,
      location: "Runda, Nairobi",
      totalOrders: 34,
      totalSpend: 89000
    },
    pro: {
      name: "Diana Chebet",
      phone: "+254 798 555 666",
      avatar: null,
      rating: 4.9,
      category: "Babysitting"
    },
    category: "Babysitting",
    location: "Runda, Nairobi",
    date: "2024-07-23",
    scheduledTime: "09:00 AM",
    price: 2000,
    paymentStatus: "paid",
    status: "completed",
    timeline: [
      { event: "Job Requested", time: "2024-07-22T08:00:00" },
      { event: "Pro Assigned", time: "2024-07-22T09:30:00" },
      { event: "Job Started", time: "2024-07-23T09:10:00" },
      { event: "Job Completed", time: "2024-07-23T17:00:00" }
    ],
    messages: [
      { sender: "customer", text: "My kids are 3 and 5", time: "2024-07-22T08:15:00" },
      { sender: "pro", text: "I have experience with toddlers", time: "2024-07-22T09:35:00" },
      { sender: "customer", text: "Perfect, thank you", time: "2024-07-22T09:40:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-007",
    jobId: "JRN-10240",
    customer: {
      name: "Mary Kariuki",
      phone: "+254 712 345 678",
      avatar: null,
      location: "Westlands, Nairobi",
      totalOrders: 12,
      totalSpend: 24500
    },
    pro: {
      name: "Moses Kiprop",
      phone: "+254 798 666 777",
      avatar: null,
      rating: 4.4,
      category: "Moving"
    },
    category: "Moving",
    location: "Westlands → Kilimani, Nairobi",
    date: "2024-07-25",
    scheduledTime: "08:00 AM",
    price: 12000,
    paymentStatus: "paid",
    status: "disputed",
    timeline: [
      { event: "Job Requested", time: "2024-07-24T09:00:00" },
      { event: "Pro Assigned", time: "2024-07-24T10:30:00" },
      { event: "Job Started", time: "2024-07-25T08:15:00" },
      { event: "Job Completed", time: "2024-07-25T14:00:00" }
    ],
    messages: [
      { sender: "customer", text: "Please handle items carefully", time: "2024-07-24T09:15:00" },
      { sender: "pro", text: "Will do", time: "2024-07-24T10:35:00" },
      { sender: "customer", text: "Some items got damaged!", time: "2024-07-25T14:30:00" }
    ],
    dispute: {
      raisedBy: "customer",
      reason: "Damaged furniture during move",
      notes: "Sofa leg broken and table scratched"
    }
  },
  {
    id: "JOB-008",
    jobId: "JRN-10241",
    customer: {
      name: "James Ndirangu",
      phone: "+254 723 456 789",
      avatar: null,
      location: "Kilimani, Nairobi",
      totalOrders: 8,
      totalSpend: 18200
    },
    pro: {
      name: "Grace Wanjiku",
      phone: "+254 798 111 222",
      avatar: null,
      rating: 4.8,
      category: "Cleaning"
    },
    category: "Cleaning",
    location: "Kilimani, Nairobi",
    date: "2024-07-28",
    scheduledTime: "10:00 AM",
    price: 1800,
    paymentStatus: "refunded",
    status: "cancelled",
    timeline: [
      { event: "Job Requested", time: "2024-07-27T11:00:00" },
      { event: "Pro Assigned", time: "2024-07-27T12:30:00" },
      { event: "Cancelled", time: "2024-07-28T09:00:00" }
    ],
    messages: [
      { sender: "customer", text: "I need to cancel", time: "2024-07-28T08:45:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-009",
    jobId: "JRN-10242",
    customer: {
      name: "Fatuma Abdalla",
      phone: "+254 778 901 234",
      avatar: null,
      location: "South B, Nairobi",
      totalOrders: 5,
      totalSpend: 8900
    },
    pro: {
      name: "Chef Kipruto",
      phone: "+254 798 777 888",
      avatar: null,
      rating: 4.5,
      category: "Catering"
    },
    category: "Catering",
    location: "South B, Nairobi",
    date: "2024-07-30",
    scheduledTime: "12:00 PM",
    price: 8500,
    paymentStatus: "pending",
    status: "assigned",
    timeline: [
      { event: "Job Requested", time: "2024-07-29T08:00:00" },
      { event: "Pro Assigned", time: "2024-07-29T09:30:00" }
    ],
    messages: [
      { sender: "customer", text: "We need food for 30 people", time: "2024-07-29T08:15:00" },
      { sender: "pro", text: "I will prepare a menu", time: "2024-07-29T09:35:00" }
    ],
    dispute: null
  },
  {
    id: "JOB-010",
    jobId: "JRN-10243",
    customer: {
      name: "Samuel Ochieng",
      phone: "+254 789 012 345",
      avatar: null,
      location: "Embakasi, Nairobi",
      totalOrders: 2,
      totalSpend: 4500
    },
    pro: {
      name: "Peter Maina",
      phone: "+254 798 888 999",
      avatar: null,
      rating: 4.3,
      category: "Electrical"
    },
    category: "Electrical",
    location: "Embakasi, Nairobi",
    date: "2024-08-01",
    scheduledTime: "09:00 AM",
    price: 2800,
    paymentStatus: "pending",
    status: "disputed",
    timeline: [
      { event: "Job Requested", time: "2024-07-31T10:00:00" },
      { event: "Pro Assigned", time: "2024-07-31T11:30:00" },
      { event: "Job Started", time: "2024-08-01T09:15:00" },
      { event: "Job Completed", time: "2024-08-01T11:00:00" }
    ],
    messages: [
      { sender: "customer", text: "Fix the lights", time: "2024-07-31T10:15:00" },
      { sender: "pro", text: "I'll check the wiring", time: "2024-07-31T11:35:00" },
      { sender: "customer", text: "The lights are still flickering!", time: "2024-08-01T11:30:00" }
    ],
    dispute: {
      raisedBy: "customer",
      reason: "Work not completed properly",
      notes: "Lights still flickering after repair"
    }
  },
  {
    id: "JOB-011",
    jobId: "JRN-10244",
    customer: {
      name: "Grace Mwangi",
      phone: "+254 700 123 456",
      avatar: null,
      location: "Gigiri, Nairobi",
      totalOrders: 15,
      totalSpend: 32000
    },
    pro: {
      name: "David Kariuki",
      phone: "+254 798 999 000",
      avatar: null,
      rating: 4.7,
      category: "Gardening"
    },
    category: "Gardening",
    location: "Gigiri, Nairobi",
    date: "2024-08-02",
    scheduledTime: "07:00 AM",
    price: 4500,
    paymentStatus: "paid",
    status: "in_progress",
    timeline: [
      { event: "Job Requested", time: "2024-08-01T09:00:00" },
      { event: "Pro Assigned", time: "2024-08-01T10:30:00" },
      { event: "Job Started", time: "2024-08-02T07:15:00" }
    ],
    messages: [],
    dispute: null
  },
  {
    id: "JOB-012",
    jobId: "JRN-10245",
    customer: {
      name: "Lucy Wanjiru",
      phone: "+254 711 234 567",
      avatar: null,
      location: "Kileleshwa, Nairobi",
      totalOrders: 6,
      totalSpend: 12800
    },
    pro: null,
    category: "Plumbing",
    location: "Kileleshwa, Nairobi",
    date: "2024-08-03",
    scheduledTime: "01:00 PM",
    price: 4200,
    paymentStatus: "pending",
    status: "requested",
    timeline: [
      { event: "Job Requested", time: "2024-08-02T15:00:00" }
    ],
    messages: [],
    dispute: null
  }
];

export function isAtRisk(job) {
  if (!job) return false;
  
  if (job.status === "disputed") return true;
  
  if (job.status === "completed" && job.paymentStatus === "pending") return true;
  
  if (job.status === "cancelled" && job.timeline && job.timeline.length > 1) return true;
  
  return false;
}